export default __webpack_public_path__ + "static/media/ci-back-new.44a4c49e.svg";